<template>
    <div class="paging-indicators text-center" v-if="items.length > 1">
        <div class="indicators">
            <button v-for="(n, i) in dots" class="indicator" :class="{'active': n.isActive}" v-on:click="changePage(n)" :aria-label="slideTranslation + ' ' + parseInt(i+1)" :aria-selected="n.isActive ? 'true' : 'false'"></button>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { outerWidth } from '../../../utils/dom.js';
    export default {
        data() {
            return {
                items: [],
                containerWidth: 0,
                totalItemsWidth: 0,
                itemsPerView: 0
            }
        },
        props: {
            activeItemIndex: Number,
            itemsSelector: String,
            itemsContainerSelector: String,
            slideTranslation : String
        },
        mounted() {
            const vm = this;
            window.addEventListener('resize', vm.updateItems);
            window.addEventListener('collapseClicked', vm.updateItems);
            this.updateItems();
        },
        computed: {
            dots() {
                const vm = this;
                const dotArr = [];
                let currWidth = 0;
                let pageStart = 0;
                let activeSet = false;
                this.items.forEach((item, i) => {
                    currWidth += item.width;
                    if (i > 0 && i % vm.itemsPerView === 0) {
                        if (currWidth > vm.containerWidth) {
                            let isActive = false;
                            if (!activeSet && (vm.activeItemIndex < i)) {
                                isActive = true;
                                activeSet = true;
                            }
                            currWidth = item.width;
                            dotArr.push({ isActive: isActive, pageStart: pageStart });
                            pageStart = i;
                        }
                    }
                });
                if (dotArr.length > 0) {
                    dotArr.push({ isActive: !activeSet, pageStart: pageStart });
                }

                return dotArr;
            }
        },
        methods: {
            changePage(e) {
                this.$emit('changepage', e);
            },
            updateItems() {
                const vm = this;
                let newItems = [];
                let newItemsWidth = 0;
                vm.$parent.$el.querySelectorAll(vm.itemsSelector).forEach((el) => {
                    const w = outerWidth(el);
                    newItemsWidth += w;
                    newItems.push({ width: w });
                });
                vm.items = newItems;
                vm.totalItemsWidth = newItemsWidth;
                vm.containerWidth = outerWidth(vm.$parent.$el.querySelector(vm.itemsContainerSelector)) - Array.prototype.slice.call(vm.$parent.$el.querySelectorAll(vm.itemsContainerSelector + ' > :not(' + vm.itemsSelector + ')')).reduce((prev, curr) => { return prev + outerWidth(curr) }, 0);
                vm.itemsPerView = window.innerWidth < 722 ? 1 : (window.innerWidth < 1200 ? 2 : 3);
            }
        }
    };
</script>